<template>
    <div class="grid grid-cols-1 gap-6 p-8 lg:grid-cols-3">
        <div>
            <h3>Base date picker</h3>
            <div>Selected date: {{ baseDatePicker }}</div>
            <DsCheckbox
                v-model="toggleError"
                class="my-4"
                label="Toggle error state"
                name="toggleError"
                value="An error has occurred"
            />
            <DsDatePicker
                v-model="baseDatePicker"
                :input="{ placeholder: 'Select date', error: toggleError ? 'An error has occurred' : undefined }"
            />
        </div>

        <div>
            <h3>Standalone calendar</h3>
            <div>Selected date: {{ standaloneDatePicker }}</div>

            <DsDatePicker
                v-model="standaloneDatePicker"
                v-model:openPicker="isCalendarPopupOpen"
                :input="{ placeholder: 'Select date', error: toggleError }"
                standaloneCalendar
            />
        </div>

        <div>
            <h3>With custom trigger</h3>
            <div>Selected date: {{ customTriggerDatePicker }}</div>

            <DsDatePicker
                v-model="customTriggerDatePicker"
                :closeOnSelect="false"
                :input="{ placeholder: 'Select date' }"
            >
                <template #trigger>
                    <DsButton
                        size="md"
                        variant="secondary"
                    >
                        Open calendar
                        <small>(Anything can be here)</small>
                    </DsButton>
                </template>
            </DsDatePicker>
        </div>

        <div>
            <h3>With some dates disabled</h3>
            <div>Selected date: {{ standaloneDatePicker }}</div>

            <DsDatePicker
                v-model="standaloneDatePicker"
                v-model:openPicker="isCalendarPopupOpen"
                :input="{ placeholder: 'Select date', error: toggleError }"
                :maxValue="createCalendarDateFromJS(dayjs().add(7, 'day').toDate())"
                :minValue="createToday()"
                standaloneCalendar
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import DsDatePicker from '@/components/design-system/form/date-picker/DsDatePicker.vue';
import DsButton from '@/components/design-system/button/DsButton.vue';
import DsCheckbox from '@/components/design-system/form/input/DsCheckbox.vue';
import { createCalendarDateFromJS, createDateValueRef, createToday } from '@/shared/utils/calendar-date-utils';
import dayjs from 'dayjs';
import { ref } from 'vue';

const isCalendarPopupOpen = ref(false);
const toggleError = ref(false);

const baseDatePicker = createDateValueRef(createCalendarDateFromJS(dayjs().subtract(1, 'day').toDate()));
const standaloneDatePicker = createDateValueRef(createToday());
const customTriggerDatePicker = createDateValueRef(createCalendarDateFromJS(dayjs().subtract(1, 'day').toDate()));
</script>
